/**
 * Breadcrumb - Navegación de breadcrumb para packing
 *
 * Componente de navegación que muestra la ruta actual en el proceso
 * de packing. Incluye:
 * - Navegación entre diferentes vistas del packing
 * - Integración con el contexto de packing
 * - Estilos consistentes con el diseño del sistema
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { PreparationBreadcrumb } from '@modules/OrderPreparation/shared';
import { usePackingContext } from '../../hooks/usePackingContext';

export const Breadcrumb = () => {
  const { t } = useTranslation('packingModule');
  const { data } = usePackingContext();

  if (!data?.preparation) {
    return null;
  }

  return (
    <PreparationBreadcrumb
      preparationCode={data.preparation.code}
      preparationStatus={data.preparation.status}
      breadcrumbLabel={t('breadcrumb.packing')}
    />
  );
};
